import type { Bulletin } from '@shared/types/Bulletin';

const HEADER = [
  'Période',
  'Matricule',
  'Nom',
  'Statut',
  'Net à payer',
  'Coût employeur',
  'Date émission',
].join(';');

function csvCell(value: string | number | undefined): string {
  const text = String(value ?? '');
  if (/[;"\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
}

export function bulletinsToCsv(
  bulletins: readonly Bulletin[],
  names: ReadonlyMap<string, string>,
): string {
  const lines = bulletins.map((b) =>
    [
      b.periode,
      b.matricule ?? '',
      b.nom_complet || names.get(b.salarie_id) || '',
      b.statut ?? 'genere',
      b.net_a_payer,
      b.cout_employeur,
      (b.date_emission || b.cree_le || '').slice(0, 10),
    ]
      .map(csvCell)
      .join(';'),
  );
  return [HEADER, ...lines].join('\n');
}
